"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function KubernetesMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__kubernetes-multitone-outline__clip0_13467_121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.338 16a1.97 1.97 0 01-.885-.206 2.02 2.02 0 01-.708-.584L.457 11.003a2.108 2.108 0 01-.406-1.77l1.18-5.24c.064-.31.195-.602.385-.853.19-.25.434-.453.712-.592L7.12.205a2.03 2.03 0 011.776 0l4.776 2.332c.276.137.518.337.708.584a2.1 2.1 0 01.388.842l1.18 5.24a2.16 2.16 0 01-.391 1.774L12.27 15.21a2.04 2.04 0 01-.706.579 1.993 1.993 0 01-.88.207H5.349L5.34 16zM8.013 1.122a.985.985 0 00-.42.097l-4.78 2.343a.936.936 0 00-.331.272.965.965 0 00-.18.394l-1.184 5.24a.962.962 0 00.19.809l3.289 4.222a.91.91 0 00.73.374h5.331a.924.924 0 00.731-.374l3.288-4.23a1.01 1.01 0 00.183-.83l-1.18-5.24a.98.98 0 00-.182-.392.95.95 0 00-.33-.271L8.426 1.219a.956.956 0 00-.413-.097z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 8.4,
    fill: "#CCE5FF",
    rx: 4,
    ry: 4.098
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.787 9.452h-.026-.066a2.066 2.066 0 00-.217-.023.529.529 0 01-.114 0 3.142 3.142 0 01-.614-.108.22.22 0 01-.128-.127v-.022l-.15-.05a4.814 4.814 0 00-.72-3.18l.115-.103V5.81a.266.266 0 01.057-.171c.16-.138.331-.26.513-.367.035-.022.07-.031.105-.059.068-.033.132-.07.195-.113a.694.694 0 01.053-.05s.026 0 .026-.022a.396.396 0 00.08-.525.329.329 0 00-.265-.13.435.435 0 00-.252.094l-.022.023c-.022 0-.035.036-.057.045-.053.052-.101.108-.146.167-.027 0-.049.06-.08.082-.132.155-.28.296-.441.42a.187.187 0 01-.101.037.13.13 0 01-.071 0h-.022l-.137.095c-.15-.163-.31-.303-.468-.453a4.526 4.526 0 00-2.388-.967v-.154h-.022a.239.239 0 01-.116-.085.248.248 0 01-.048-.137c-.004-.21.007-.42.036-.628a.369.369 0 01.035-.118c0-.068.022-.14.035-.222v-.117a.375.375 0 00-.089-.285.358.358 0 00-.266-.122.35.35 0 00-.267.122.369.369 0 00-.089.285v.095c0 .075.013.15.036.221a3.242 3.242 0 01.057.75.236.236 0 01-.093.15l-.022.027v.15c-.207.02-.413.052-.618.095a4.389 4.389 0 00-2.286 1.32l-.115-.086h-.07a.2.2 0 01-.102-.036A3.021 3.021 0 014 4.69a.487.487 0 00-.084-.082 1.644 1.644 0 00-.145-.167.336.336 0 01-.058-.045h-.022A.396.396 0 003.44 4.3a.316.316 0 00-.265.131.396.396 0 00.08.525h.026c.026 0 .03.031.057.045.061.042.125.082.19.118a.311.311 0 01.106.058c.182.103.353.224.512.362a.218.218 0 01.057.176v.023l.115.104a.545.545 0 00-.057.095 4.673 4.673 0 00-.64 3.089l-.146.045a.286.286 0 01-.124.131c-.202.056-.409.09-.618.104a1.342 1.342 0 00-.331.027h-.066a.039.039 0 00-.035 0 .366.366 0 00-.234.153.383.383 0 00-.062.277c.02.082.067.155.134.205.067.05.15.073.232.066.03.007.06.007.088 0h.071a.916.916 0 00.203-.081c.035 0 .07-.036.106-.045a2.7 2.7 0 01.565-.131h.022a.27.27 0 01.15.058h.022l.16-.022c.275.87.796 1.636 1.496 2.202.157.123.32.236.49.34l-.07.149v.022a.264.264 0 010 .19c-.082.192-.18.375-.296.547-.023.037-.045.06-.071.095-.045.06-.087.121-.124.186a.336.336 0 00-.035.059.056.056 0 010 .022.379.379 0 00.146.502c.042.022.089.034.137.036a.435.435 0 00.344-.221.033.033 0 010-.023.228.228 0 01.03-.059c.029-.069.052-.14.071-.212l.036-.104c.057-.204.137-.4.238-.584.044-.072.102-.081.146-.108a.03.03 0 00.026 0l.08-.154c.51.2 1.051.303 1.598.303.334.003.668-.035.993-.113a6.83 6.83 0 00.592-.176l.07.126h.022a.214.214 0 01.15.104c.094.189.174.383.239.584l.035.104c.018.072.04.143.066.212l.036.06v.022c.03.066.079.121.139.16.06.04.13.06.2.061a.342.342 0 00.309-.244.46.46 0 00.058-.253v-.023a.968.968 0 00-.159-.244c-.022-.036-.044-.059-.066-.095a2.537 2.537 0 01-.322-.543.334.334 0 010-.19v-.022l-.053-.14a4.467 4.467 0 001.505-1.51c.204-.328.366-.68.481-1.05l.137.022h.022a.288.288 0 01.146-.058h.026c.203.038.4.097.592.176a.694.694 0 00.101.045c.067.036.136.065.208.086h.066a.039.039 0 01.035 0c.03.005.06.005.089 0 .08.002.16-.024.226-.072a.388.388 0 00.14-.195.457.457 0 00-.107-.245.44.44 0 00-.224-.139h.035zM8.49 8.878L8 9.126l-.503-.244-.12-.556.34-.452h.543l.345.452-.115.552zm2.98-1.217c.088.387.115.785.08 1.18l-1.767-.515a.311.311 0 01-.17-.148.3.3 0 01.042-.354l1.382-1.275c.202.345.351.72.441 1.112h-.008zm-.985-1.809L8.993 6.938a.299.299 0 01-.402-.068.27.27 0 01-.057-.131l-.102-1.904c.782.085 1.511.443 2.066 1.013l-.013.004zm-3.31-.959l.366-.072-.102 1.872a.324.324 0 01-.096.214.31.31 0 01-.213.09.277.277 0 01-.137-.032L5.475 5.852a3.443 3.443 0 011.7-.959zM4.94 6.55l1.36 1.22a.31.31 0 01.11.22.32.32 0 01-.079.233.234.234 0 01-.137.095l-1.766.524c-.07-.8.109-1.603.512-2.292zm-.309 3.165l1.815-.316a.308.308 0 01.204.062c.059.045.1.11.118.182a.384.384 0 010 .19l-.715 1.723a3.658 3.658 0 01-1.426-1.836l.004-.005zm4.168 2.33a3.643 3.643 0 01-1.951-.096l.883-1.673a.303.303 0 01.366-.081.525.525 0 01.137.126l.883 1.628c-.102.037-.217.06-.331.095h.013zm2.207-1.629c-.28.456-.653.844-1.095 1.135l-.72-1.768a.32.32 0 01.017-.21.309.309 0 01.143-.152.389.389 0 01.163-.031l1.823.312a2.29 2.29 0 01-.33.714z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__kubernetes-multitone-outline__clip0_13467_121"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

KubernetesMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
KubernetesMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = KubernetesMultitoneOutline;
exports["default"] = _default;